import { SagaIterator } from 'redux-saga';
import { call, takeEvery } from 'redux-saga/effects';

import { IToastOptions, ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Tableau } from '~src/commonInfra/utils/TableauLog';

import { Messages } from '../../../codegen/Localize';
import { RequestFailed } from '../actions/AppActionTypes';
import { Failure, RequestFailedAction } from '../actions/RequestFailedAction';

export function popToast(toast: IToastOptions) {
  const service = ToasterService.instance;
  service.pop(toast);
}

export function logError(failure: Failure) {
  if (failure.error) {
    Tableau.Logger().error(failure.error);
  } else {
    Tableau.Logger().error(failure.reason);
  }
}

export function* processFailedRequest(action: RequestFailedAction) {
  if (action.failure.isDismissDialog) {
    return;
  }

  yield call(logError, action.failure);
  yield call(popToast, {
    text: action.localizedMessage ? action.localizedMessage : Messages.errorUnknown(),
    type: ToastType.Error
  });
}

export function* rootRequestFailedSaga(): SagaIterator {
  yield takeEvery(RequestFailed, processFailedRequest);
}
